const originalWarn = console.warn;
const originalError = console.error;

console.warn = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Unsupported style property')
  ) {
    return;
  }
  originalWarn.apply(console, args);
};

console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Unsupported style property')
  ) {
    return;
  }
  originalError.apply(console, args);
};
